// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"lightbulb"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M11.9998 0.999879C15.9698 1.0019 19.1998 4.23028 19.1998 8.19988C19.1998 9.28948 18.9833 10.1185 18.4926 11.3071C18.0019 12.4956 16.7461 15.0037 16.0039 16.9999H7.99609C7.28648 14.9986 6.00366 12.4962 5.5086 11.3071C5.01355 10.1179 4.7998 9.28948 4.7998 8.19988C4.7998 4.23028 8.02981 0.997856 11.9998 0.999879Z","fill-rule":"evenodd","clip-rule":"evenodd"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.5 20H15.5M10.5 23H13.5M11.9998 0.999879C15.9698 1.0019 19.1998 4.23028 19.1998 8.19988C19.1998 9.28948 18.9833 10.1185 18.4926 11.3071C18.0019 12.4956 16.7461 15.0037 16.0039 16.9999H7.99609C7.28648 14.9986 6.00366 12.4962 5.5086 11.3071C5.01355 10.1179 4.7998 9.28948 4.7998 8.19988C4.7998 4.23028 8.02981 0.997856 11.9998 0.999879Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-lightbulb')
export default class LightbulbIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'lightbulb',
    }
  }
}
